import { getQuestionList, submitQuestion } from './../../api/index'
import useRequest from '@ahooksjs/use-request'

export const useQuestionList = (params: { qid: string; user_id: number }) => {
	return useRequest(() => getQuestionList(params))
}
export const useSubmitQuestion = () => useRequest(submitQuestion, { manual: true })
